
import { mapActions, mapGetters } from 'vuex'
import store from '../../config/store'

export default {

  components: {
    ComponentAlert: () => import(/* webpackChunkName: "components" */ '@/common/components/Alert.vue'),
    LoaderSpinner: () => import(/* webpackChunkName: "components" */ '@/common/components/LoaderSpinner.vue')
  },
  
  data: () => ({
    store,
    loading: true,
    topUp: {}
  }),
  
  computed: {
    ...mapGetters([
    ]),
  },

  mounted () {
    this.loading = true
    this.getTopUpDetail(store.sidepanel.dataModel.id).then(({ data }) => {
      this.loading = false
      this.topUp = data
    }, () => {
      this.hideSidePanel()
    })
  },
  
  methods: {
    ...mapActions([
      'getTopUpDetail'
    ])
  }
}
